import { render, staticRenderFns } from "./indexActivity.vue?vue&type=template&id=b87ccfa8&scoped=true"
import script from "./indexActivity.vue?vue&type=script&lang=js"
export * from "./indexActivity.vue?vue&type=script&lang=js"
import style0 from "./indexActivity.vue?vue&type=style&index=0&id=b87ccfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87ccfa8",
  null
  
)

export default component.exports